package diana.soleil.design.iraniancanadienbazzar.core.model

/**
 * A community review on a business (`reviews/{authorUid}_{businessId}` — one per user per business,
 * rule-enforced; see `docs/DATA_MODEL.md`). `rating`/`reviewCount` aggregates on the business are
 * recomputed server-side by the `onReviewWritten` Function; clients never write them.
 */
data class Review(
    val id: String,
    val businessId: String,
    val authorUid: String,
    val authorName: String,
    val rating: Int,
    val comment: String,
    val tags: List<String> = emptyList(),
    val ownerReply: String? = null,
    /** Epoch milliseconds; null on legacy docs without a timestamp. */
    val createdAtMillis: Long? = null,
)
